import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { EstadoCrudHttpService } from '../../../../home/estado/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-estado-multiselect',
  templateUrl: './novo-estado-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoEstadoMultiselectComponent),
      multi: true,
    },
  ],
})
export class NovoEstadoMultiselectComponent extends CustomControlValueAccessor<number[]> {
  @Input() idsEstados: number[];
  @Input() variante: 'filtro' | undefined;
  @Input() icon = 'fa-map-marker-alt';
  @Output() idsEstadosChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os estados',
    plural: 'Estados',
    singular: 'Estado',
    searchEmptyResultMessage: 'Nenhum estado encontrado',
    showFooter: false
  };

  options: IOption[] = [];

  constructor(
    private messageService: MessageService,
    private estadoCrudHttpService: EstadoCrudHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private create() {
    this.definirCarregando(true);

    this.estadoCrudHttpService
      .search()
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (entities) => {
          if (entities) {
            const currentIds = this.value ?? [];
            this.options = entities.map((entity) => ({
              id: entity.id,
              label: entity.nome,
              isChecked: currentIds.includes(entity.id)
            }));
          }
        },
        (error: ApiError) => {
          this.messageService.error(
            error.message,
            'Erro ao pesquisar os estados',
            error
          );
        }
      );
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    this.idsEstados = newValue;
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSearch() {
    this.idsEstadosChange.emit(this.value);
  }

  onSelectionChange() {
    this.emitChange(this.idsEstados);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
